import { FC } from 'react';
import BottomBarWrapper from '@campaigns/src/components/bottom-bar/BottomBarWrapper';
import { Button, Icon } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { FLOWS_PRODUCTS_PATH } from '@flows/src/FlowsProductsRouter';
import useFlowsProductSelectionStore from '@flows/src/store/zustand/flows-products/flowsProductSelectionStore';
import { useFlowProductsOverviewParams } from '@flows/src/hooks/flow-products/useFlowProductsOverviewParams';
import BottomBarBasketActions from '@flows/src/components/flow-products/quotes/basket/BottomBarBasketActions';

interface Props {
  handlePrevious?: () => void;
  backText?: string;
}

const FlowProductsBottomBar: FC<Props> = ({ handlePrevious, backText }) => {
  const { t } = useTranslation();
  const { flowId } = useFlowProductsOverviewParams();
  const isBasketPage = window.location.pathname.includes('basket');
  const isBasketEmpty = useFlowsProductSelectionStore(
    (state) => !(state.selectedItems.length > 0),
  );
  const history = useHistory();

  const handleNavigation = () => {
    history.push({
      pathname: `${FLOWS_PRODUCTS_PATH}/${flowId}/basket`,
      search: window.location.search,
    });
  };

  return (
    <BottomBarWrapper>
      {handlePrevious && (
        <Button
          flexShrink={0}
          onClick={handlePrevious}
          leftIcon={<Icon name="GeneralActionsArrowLeft" />}
          variant="white"
        >
          {backText}
        </Button>
      )}
      {!isBasketPage ? (
        <Button
          flexShrink={0}
          ml="auto"
          onClick={handleNavigation}
          isDisabled={isBasketEmpty}
          rightIcon={<Icon name="GeneralActionsArrowRight" />}
        >
          {t('CAMPAIGNS_DETAIL-CHOSEN_PRODUCTS')}
        </Button>
      ) : (
        <BottomBarBasketActions />
      )}
    </BottomBarWrapper>
  );
};

export default FlowProductsBottomBar;
